import { isNumberInRange } from './validations';

export type BaseNumericValidation = (value: number | null) => string | null;
export type BaseTextValidation = (value: string | null) => string | null;

export const getNumberInRangeValidation = (
  min: number,
  max: number,
  errText: string
): BaseNumericValidation => {
  return (value: number | null) =>
    isNumberInRange(value, min, max) ? null : errText;
};
